export const CONSTANTS = {
    IMAGE: {
        width: 300,
        height: 80,
        suboperation: null
    }
};

//# sourceMappingURL=constants.js.map